import React from "react";
import Layout from "../Componants/Layout";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation, } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";

export default function VendorPortfolioDetail() {
  const Navigate = useNavigate();
  const Location = useLocation();

  const {
    data: electricianPortfolioDetail,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["electricianPortfolioDetail"],
    queryFn: () => {
      const url = `portfolio/info${Location.search}`;
      return getRequest(url); // Ensure the result of getRequest is returned
    },
    enabled: !!Location?.search, // Ensure the query only runs if Location.search exists
  });


  console.log(electricianPortfolioDetail, "electricianPortfolioDetail")


  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate(-1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Back
            </h3>
          </div>
          <div className="portfolio-gellary">

            {Array.isArray(electricianPortfolioDetail?.data?.image) && electricianPortfolioDetail?.data?.image.length > 0 ?

              <>
                {electricianPortfolioDetail?.data?.image.map((ele, index) => {
                  return (
                    <>
                      <img key={index}
                        src={ele}
                        className={index == 0 ? " main-big-img" : ""}
                      />
                    </>
                  )
                })}
              </> :
              <>
                <img
                  src={require("../assets/images/dimmy-img.png")}
                  className="main-big-img"
                />

                <img src={require("../assets/images/dimmy-img.png")} />
                <img src={require("../assets/images/dimmy-img.png")} />
                <img src={require("../assets/images/dimmy-img.png")} />
                <img src={require("../assets/images/dimmy-img.png")} />

              </>
            }



          </div>
          <div className="portfolio-data">
            <h3>{electricianPortfolioDetail?.data?.projectName}</h3>
            {/* <p className="portfolio-title-txt-b">Project Category - Subcategory</p> */}
            <p className="mb-0">

              {electricianPortfolioDetail?.data?.description}
            </p>

          </div>
        </Container>
      </Layout>
    </>
  );
}
